(() => {
  window.AW = window.AW || {};

  class AWMainProductWishlist {
    constructor({ root, requestSync }) {
      this.root = root;
      this.requestSync = requestSync;
      this.wishlistObserver = null;
      this.wishlistButtonObserver = null;
      this.mutationFrame = null;
      this.wishlistButton = null;
      this.wishlistTriggers = [];
      this.wishlistTriggerIcons = [];
      this.wishlistTriggerTexts = [];
      this.wishlistAnchor = null;
      this.wishlistIconDefault = "";
      this.wishlistIconActive = "";
      this.onMutate = this.onMutate.bind(this);

      this.refresh();
    }

    refresh() {
      this.wishlistTriggers = Array.from(this.root.querySelectorAll("[data-aw-wishlist-trigger]"));
      this.wishlistTriggerIcons = Array.from(this.root.querySelectorAll("[data-aw-wishlist-trigger-icon]"));
      this.wishlistTriggerTexts = Array.from(this.root.querySelectorAll("[data-aw-wishlist-trigger-text]"));
      this.mediaGrid = this.root.querySelector(".product__grid");
      this.wishlistAnchor = this.root.querySelector("[data-aw-wishlist-anchor]");
      this.wishlistButton =
        this.root.querySelector("#swym-atw-pdp-button")
        || document.querySelector("#swym-atw-pdp-button");
      this.wishlistIconDefault = this.root.dataset.wishlistIconDefault || "";
      this.wishlistIconActive = this.root.dataset.wishlistIconActive || "";

      this.observeWishlistArea();
      this.observeWishlistButton();
      this.syncIcon();
    }

    destroy() {
      if (this.wishlistObserver) {
        this.wishlistObserver.disconnect();
        this.wishlistObserver = null;
      }

      if (this.wishlistButtonObserver) {
        this.wishlistButtonObserver.disconnect();
        this.wishlistButtonObserver = null;
      }

      if (this.mutationFrame !== null) {
        window.cancelAnimationFrame(this.mutationFrame);
        this.mutationFrame = null;
      }

      this.wishlistButton = null;
      this.wishlistTriggers = [];
      this.wishlistTriggerIcons = [];
      this.wishlistTriggerTexts = [];
      this.wishlistAnchor = null;
    }

    handleClick(event) {
      const wishlistButton = event.target.closest("#swym-atw-pdp-button");

      if (wishlistButton && this.root.contains(wishlistButton)) {
        this.requestSync([80, 220, 420]);
        return true;
      }

      const customWishlistButton = event.target.closest("[data-aw-wishlist-trigger]");

      if (customWishlistButton && this.root.contains(customWishlistButton)) {
        event.preventDefault();
        this.toggle();
        return true;
      }

      return false;
    }

    observeWishlistArea() {
      if (this.wishlistObserver) {
        this.wishlistObserver.disconnect();
        this.wishlistObserver = null;
      }

      if (!(this.mediaGrid instanceof HTMLElement)) {
        return;
      }

      this.wishlistObserver = new MutationObserver(this.onMutate);
      this.wishlistObserver.observe(this.mediaGrid, {
        childList: true,
        subtree: true
      });
    }

    observeWishlistButton() {
      if (this.wishlistButtonObserver) {
        this.wishlistButtonObserver.disconnect();
        this.wishlistButtonObserver = null;
      }

      if (!(this.wishlistButton instanceof HTMLElement)) {
        return;
      }

      this.wishlistButtonObserver = new MutationObserver(this.onMutate);
      this.wishlistButtonObserver.observe(this.wishlistButton, {
        attributes: true,
        attributeFilter: ["class", "aria-label"]
      });
    }

    onMutate() {
      if (this.mutationFrame !== null) {
        return;
      }

      this.mutationFrame = window.requestAnimationFrame(() => {
        this.mutationFrame = null;
        this.requestSync([0]);
      });
    }

    syncIcon() {
      if (!(this.wishlistButton instanceof HTMLElement)) {
        this.root.classList.remove("aw-main-product--wishlist-ready");
        this.syncTriggerState(false);
        return;
      }

      const defaultIcon = this.wishlistIconDefault || "";
      const activeIcon = this.wishlistIconActive || defaultIcon;
      const isAdded = this.wishlistButton.classList.contains("atw-button-added");
      this.root.classList.add("aw-main-product--wishlist-ready");
      this.syncTriggerState(isAdded, { defaultIcon, activeIcon });
    }

    syncTriggerState(isAdded, icons = {}) {
      const firstTriggerIcon = this.wishlistTriggerIcons.find((image) => image instanceof HTMLImageElement) || null;
      const defaultIcon = icons.defaultIcon || this.wishlistIconDefault || firstTriggerIcon?.getAttribute("src") || "";
      const activeIcon = icons.activeIcon || this.wishlistIconActive || defaultIcon;
      const nextSrc = isAdded ? activeIcon : defaultIcon;
      const nextLabel = isAdded ? "Added to wishlist" : "Add to wishlist";

      this.wishlistTriggers.forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) {
          return;
        }

        button.hidden = !(this.wishlistButton instanceof HTMLElement);
        button.setAttribute("aria-pressed", isAdded ? "true" : "false");
        button.setAttribute("aria-label", nextLabel);
      });

      this.wishlistTriggerIcons.forEach((image) => {
        if (!(image instanceof HTMLImageElement)) {
          return;
        }

        if (nextSrc && image.getAttribute("src") !== nextSrc) {
          image.setAttribute("src", nextSrc);
        }

        image.setAttribute("width", "24");
        image.setAttribute("height", "20");
      });

      this.wishlistTriggerTexts.forEach((text) => {
        if (text instanceof HTMLElement) {
          text.textContent = nextLabel;
        }
      });
    }

    toggle() {
      if (!(this.wishlistButton instanceof HTMLElement)) {
        return;
      }

      this.wishlistButton.click();
      this.requestSync([80, 220, 420, 700]);
    }
  }

  window.AW.MainProductWishlist = AWMainProductWishlist;
})();
